import { BrowserRouter } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Layout from './components/Layout/layout';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './context/AuthContext';
import {ThemeProvider} from './components/theme/ThemeProvider';
import './index.css';
// above css file acts as a fallback

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
        <ScrollToTop />
          <AppRoutes />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;